export default __webpack_public_path__ + "static/media/kayla-overchuk.2e048501.jpg";